<div class="component-container">
    <div class="content">
        <ng-content></ng-content>
    </div>
    <div class="spinner-container">
        <mat-progress-spinner class="spinner" mode="indeterminate">
        </mat-progress-spinner>
    </div>
</div>